module.exports = __webpack_public_path__ + "assets/img/mosaic-columns-5.b3315640.jpg";